import axios from "../library/axios";
import { MySwal } from "../library/swal";
import { getSlug } from "../config/routes/guards/slug";

// Unduhan berkas TIDAK boleh memakai URL statis di kolom `link` karena URL itu
// dilayani reverse proxy tanpa mengenal token. Semua unduhan lewat endpoint
// ber-auth supaya group yang dilarang mengunduh benar-benar tertahan di server.

const tokenHeader = () => ({
  Authorization: `Bearer ${localStorage.getItem(
    `token${getSlug() ? "-" + getSlug() : ""}`
  )}`,
});

// Nama berkas yang dikirim server lewat header Content-Disposition.
const filenameFromDisposition = (disposition) => {
  if (!disposition) return "";

  const utf8 = /filename\*=UTF-8''([^;]+)/i.exec(disposition);
  if (utf8 && utf8[1]) {
    try {
      return decodeURIComponent(utf8[1]);
    } catch (err) {
      // Nama tidak bisa di-decode; pakai fallback dari pemanggil.
    }
  }

  const plain = /filename="?([^";]+)"?/i.exec(disposition);
  return plain && plain[1] ? plain[1].trim() : "";
};

// Karena responseType-nya blob, balasan error pun datang sebagai Blob sehingga
// JSON-nya perlu dibaca dulu untuk mengambil pesan dari server.
const messageFromError = async (err, fallback) => {
  const body = err?.response?.data;

  if (typeof Blob !== "undefined" && body instanceof Blob) {
    try {
      const parsed = JSON.parse(await body.text());
      if (parsed?.message) return parsed.message;
    } catch (parseError) {
      // Bukan JSON; pakai fallback.
    }
  }

  if (body && typeof body === "object" && body.message) return body.message;
  return fallback;
};

/**
 * Unduh satu berkas dokumen lewat endpoint ber-auth.
 * Melempar error bila gagal; pemanggil yang menentukan tampilan pesannya.
 */
export const downloadDocumentFile = async (downloadPath, fallbackName = "dokumen") => {
  const { data, headers } = await axios({
    url: downloadPath,
    method: "GET",
    responseType: "blob",
    // 403 di sini berarti "group Anda tidak boleh mengunduh", bukan sesi habis.
    skipForbiddenLogout: true,
    headers: { "Access-Control-Allow-Origin": "*", ...tokenHeader() },
  });

  const namaBerkas =
    filenameFromDisposition(headers?.["content-disposition"]) || fallbackName;

  const objectUrl = window.URL.createObjectURL(data);
  const anchor = document.createElement("a");
  anchor.href = objectUrl;
  anchor.setAttribute("download", namaBerkas);
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  window.URL.revokeObjectURL(objectUrl);
};

/**
 * Sama seperti downloadDocumentFile, tapi kegagalannya langsung ditampilkan
 * sebagai alert. Mengembalikan true bila unduhan berhasil dimulai.
 */
export const downloadDocumentWithAlert = async (downloadPath, fallbackName) => {
  try {
    await downloadDocumentFile(downloadPath, fallbackName);
    return true;
  } catch (err) {
    // Sesi habis sudah ditangani (beserta pesannya) oleh interceptor axios.
    if (err?.isHandledByInterceptor) return false;

    MySwal.fire({
      icon: "error",
      title: "Dokumen Gagal Diunduh",
      text: await messageFromError(
        err,
        "Dokumen gagal diunduh. Silakan coba lagi, dan hubungi administrator bila tetap gagal."
      ),
    });
    return false;
  }
};
